// extracted by mini-css-extract-plugin
export default {"name":"SharedTextFieldLabel_name__ACCHs"};